import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { adminConfig, isLocalEnvironment, requiresAuthentication } from './config/admin';

// Components
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Sessions from './pages/Sessions';
import Actions from './pages/Actions';
import Finance from './pages/Finance';
import Usage from './pages/Usage';
import Models from './pages/Models';
import ApiKeys from './pages/ApiKeys';
import Settings from './pages/Settings';
import System from './pages/System';
import RuntimeStatus from './pages/RuntimeStatus';
import Memory from './pages/Memory';
import Login from './pages/Login';
import Loading from './components/Loading';

// Context
import { AuthProvider, useAuth } from './contexts/AuthContext';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return <Loading />;
  }

  if (!requiresAuthentication()) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="users/:userId" element={<UserDetail />} />
        <Route path="sessions" element={<Sessions />} />
        <Route path="actions" element={<Actions />} />
        <Route path="finance" element={<Finance />} />
        <Route path="usage" element={<Usage />} />
        <Route path="models" element={<Models />} />
        <Route path="api-keys" element={<ApiKeys />} />
        <Route path="settings" element={<Settings />} />
        <Route path="system" element={<System />} />
        <Route path="runtime-status" element={<RuntimeStatus />} />
        <Route path="memory" element={<Memory />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App; 